import { transliterate } from 'transliteration';

export default val => transliterate(val.replace(/¿/g, '')).replace(/[`´]/g, "'");
